import api from "../../services/api";

const SET_ARTICLE = "SET_ARTICLE"; // harus sama dengan mutation
const SET_ARTICLES = "SET_ARTICLES"; // harus sama dengan mutation

// harus sama dengan actions ~> store/index.js
export const ACTION_SET_ARTICLE = "setArticle";
export const ACTION_SET_ARTICLES = "setArticles";

export const STATE = {
  articles: {},
  articles_single: {}
};

export const ACTION = {
  ARTICLE: ({ commit }, payload) => {
    return api
      .post(api.route.get.article, { slug: payload.slug })
      .then(res => commit(SET_ARTICLE, res))
      .catch(err => console.log(err));
  },
  ARTICLES: ({ commit }, payload) => {
    return api
      .post(api.route.get.articles, payload)
      .then(res => {
        let newData = {};
        if (payload.data === undefined) newData = res;
        else {
          let mergeArray = payload.data.data.concat(res.data);
          newData = {
            ...payload.data,
            data: mergeArray
          };
        }
        commit(SET_ARTICLES, newData);
      })
      .catch(err => console.log(err));
  }
};

export const GETTER = {
  ARTICLE: state => {
    return state.STATE_PAGES.articles_single;
  },
  ARTICLES: state => {
    let articles = state.STATE_PAGES.articles;
    return articles;
  }
};

export const MUTATION = {
  SET_ARTICLE: (state, page) => {
    state.STATE_PAGES.articles_single = page;
  },
  SET_ARTICLES: (state, page) => {
    state.STATE_PAGES.articles = page;
  }
};



// WEBPACK FOOTER //
// ./src/store/repo/pages.js